import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as SuccessIcon } from "../assets/icons/successCheck.svg";

export default function SuccessPopup({
  isOpen,
  title = "Success",
  message = "Data mapped successfully",
  duration = 3000,
  onClose,
}) {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose, duration]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
          backdropFilter: "blur(2px)",
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            width: "480px",
            padding: "40px 24px 32px 24px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Icon in Top Right */}
          <CloseIcon
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "14px",
              height: "14px",
              cursor: "pointer",
              color: "#205a46",
            }}
            onClick={onClose}
          />

          {/* Green Checkmark Circle Icon */}
          <div style={{ marginBottom: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <SuccessIcon width="90" height="90" />
          </div>

          {/* Centered Message */}
          <p
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: "500",
              fontSize: "18px",
              lineHeight: "1.4",
              color: "#111111",
              textAlign: "center",
              margin: "0 0 24px 0",
              width: "100%",
            }}
          >
            {message}
          </p>

          {/* OK Button */}
          <button
            style={{
              width: "80px",
              height: "36px",
              borderRadius: "6px",
              backgroundColor: "#205a46",
              color: "#FFFFFF",
              fontFamily: "DM Sans",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={onClose}
          >
            OK
          </button>
        </motion.div>
      </div>
    </AnimatePresence>,
    document.body
  );
}
